import { render, staticRenderFns } from "./signosVitalesCard.vue?vue&type=template&id=6ce06b77&scoped=true&"
import script from "./signosVitalesCard.vue?vue&type=script&lang=js&"
export * from "./signosVitalesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce06b77",
  null
  
)

export default component.exports